import { createRoot } from 'react-dom/client'
import App from './App.tsx';
import './index.css'

// Mark body as loaded once React mounts to prevent FOUC
document.body.classList.add('loaded');

createRoot(document.getElementById("root")!).render(<App />);
